module.exports = {
  alerts: ($stateParams, Api) ->
    Api.MonitoringSubjectAlerts.get(subject: $stateParams.subjectId, outstanding_only: true).$promise
}
